import '../styles/styles.scss';

import 'core-js/stable';
import 'focus-visible';
import 'element-closest-polyfill';

import { setupConditionalTogglers } from './shared/visibility-toggler';

import { initB2C, isB2cpage } from './templates/b2c';
import { authTemplate } from './templates/auth';
import { accountLinkedPage, initAccountLinkedPage } from "./templates/account-linked";


/**
 * Logic to enhance native B2C authentication flow
 **/


/**
 * Initialize
 **/
const init = () => {
    /**
     * Init B2C templates
     */

    if (isB2cpage) {
        initB2C();
    }


    /**
     * Init specific pages
     */

    if (accountLinkedPage) {
        initAccountLinkedPage();
    }
};


/**
 * Execute when DOM content is loaded
 **/
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

/**
 * Execute when whole page is loaded
 */
window.onload = function () {
    const autoFocusField = document.getElementById(authTemplate.dataset.autofocusId);

    if (isB2cpage && !!autoFocusField) {
        autoFocusField.focus();
    }
};
